const stageFirebaseConfig = {
    apiKey: "AIzaSyDtd23adWHMUeC8C-vFpcHIibyofYj1uUM",
    authDomain: "courtclickstage.firebaseapp.com",
    projectId: "courtclickstage",
    storageBucket: "courtclickstage.firebasestorage.app",
    messagingSenderId: "586106822649",
    appId: "1:586106822649:web:a6a528193f8b110cd4e728",
    measurementId: "G-GZCPYCCF67"
};

const productionFirebaseConfig = {
    apiKey: "AIzaSyCCdRGb-XlG4liTNInN0waR1DG_C2JRp5M",
    authDomain: "courtclickapp.firebaseapp.com",
    projectId: "courtclickapp",
    storageBucket: "courtclickapp.appspot.com",
    messagingSenderId: "228947922443",
    appId: "1:228947922443:web:12c91bc9a0241dd576010e",
    measurementId: "G-47J7EVHE3P"
};

const firebaseTarget = process.env.REACT_APP_FIREBASE_TARGET ||
    (process.env.NODE_ENV === 'production' ? 'production' : 'stage');

const baseFirebaseConfig = ['production', 'prod', 'main'].includes(firebaseTarget.toLowerCase())
    ? productionFirebaseConfig
    : stageFirebaseConfig;

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || baseFirebaseConfig.apiKey,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || baseFirebaseConfig.authDomain,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || baseFirebaseConfig.projectId,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || baseFirebaseConfig.storageBucket,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || baseFirebaseConfig.messagingSenderId,
    appId: process.env.REACT_APP_FIREBASE_APP_ID || baseFirebaseConfig.appId,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || baseFirebaseConfig.measurementId
};

export const firebaseProjectTarget = firebaseTarget;
